import { createContext, useContext } from "react";

export const ThemeContext = createContext({
  primaryColor: "#033AB5",
  secondaryColor: "#FF6200",
  textColor: "#FFFFFF",
  className: "unleash-blue",
});

export const useTheme = () => useContext(ThemeContext);
